// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bgy_a bho_ea bho_a","LoadingSwitch__init":"bgy_b bho_a bho_w bho_j bho_ul bho_um bho_fm"};